import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createPinia } from 'pinia'
import axios from 'axios'

//axios.defaults.baseURL = 'http://127.0.0.1:8000'
axios.defaults.baseURL = 'https://resdbackend-hvgio2nhhq-pd.a.run.app/'

loadFonts()

createApp(App)
  .use(router, axios)
  .use(vuetify)
  .use(createPinia())
  .mount('#app')
